module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "p6",
      "title": "6"
    }
  }, [_c('h1', {
    staticClass: "mattertitle",
    attrs: {
      "id": "AA1"
    }
  }, [_vm._v("Make-It-Easy Freezer Meals")]), _vm._v(" "), _c('p', {
    staticClass: "para_intro"
  }, [_vm._v("Making meals ahead doesn’t mean you need to be uber-organized or in the kitchen all day. Consider this book your one-stop cheat sheet—giving you all the tips and tricks you’ll need to easily make meals in advance. Just think how good it will feel to have delicious meals on-hand—ready to pull out and cook or reheat with little effort. Never be caught by the “what’s for dinner?” question again!")]), _vm._v(" "), _c('h2', {
    staticClass: "head"
  }, [_vm._v("Top Tips for Freezing")]), _vm._v(" "), _c('p', {
    staticClass: "list_bulleted"
  }, [_vm._v("Freshness Counts")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("You get out what you put in. Freezing can be tough on foods—it won’t improve the quality—so start by using ingredients at their freshest: vegetables and herbs at their peak ripeness and fresh meat and poultry with good color and no odor. Set your freezer to 0°F or lower so that foods come through the freezing/thawing process successfully.")]), _vm._v(" "), _c('p', {
    staticClass: "list_bulleted"
  }, [_vm._v("Freeze Only Once As Is")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("To get the best from your meals once they’ve been frozen and avoid potential food safety issues, always follow this rule: Ingredients can be frozen only once in their current condition: once raw (uncooked) and once cooked.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Example: You’ve thawed ground beef to use for a recipe but then realize you don’t have time to make the recipe. Do not refreeze the uncooked ground beef; but you can brown, cool and then freeze it now because it’s cooked. When you’re ready to make your recipe, you’re now one step ahead! Thaw the ground beef and continue as directed.")]), _vm._v(" "), _c('p', {
    staticClass: "list_bulleted"
  }, [_vm._v("Dress for Success")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Package your meals in wraps that can take the arctic blast of your freezer—freezer plastic wrap, foil or containers specifically designed for freezer use.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Prevent freezer burn by removing as much air from packages as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Freeze food in realistically sized portions. If the recipe you cooked made eight servings and you are a family of three, consider packaging the recipe for the freezer into smaller sizes, so you will use just what you need and save the remaining portion for another meal.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Help foods freeze quickly to retain better quality: allow space between them while freezing, and freeze in shallow containers instead of upright, deeper ones.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Freeze purchased frozen foods in their original packaging.")]), _vm._v(" "), _c('p', {
    staticClass: "list_bulleted"
  }, [_vm._v("Label All Packages")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("You might be tempted to skip this step, thinking that you’ll know what the food is when you go to use it. But given time (out of sight, out of mind) and frosty containers, there’s a good chance that when you pull it from the freezer, you won’t know what the mystery package is!")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Always label packages with the date and name of the recipe. If using a freezer bag, write any further directions for completing the recipe (such as bake temp and time) right on the bag so you don’t have to pull out the recipe again when you’re ready to make the dish.")]), _vm._v(" "), _c('p', {
    staticClass: "list_bulleted"
  }, [_vm._v("First In, First Out")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Use up what you first put in the freezer before using more recently frozen foods. That way, you can keep on top of what’s in there and nothing gets wasted due to being stored too long. If you have a chest-style freezer and hate to dig, keep a list near it that shows what you put in and when. Cross it off the list when you take it out.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a37393b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/p006.vue
// module id = 72
// module chunks = 0